import {
  cssProp,
  observableValue,
  useSharedState,
  view,
  View,
} from '@esui/core';
import '@material/mwc-tab-bar';
import { html } from 'lit';

class Props {
  activeIndex = observableValue(0);
  tabs: View[] = [];

  @cssProp('--mdc-tab-height')
  tabHeight?: string = undefined;
  @cssProp('--mdc-tab-horizontal-padding')
  tabHorizontalPadding?: string = undefined;
  @cssProp('--mdc-tab-stacked-height')
  tabStackedHeight?: string = undefined;
  @cssProp('--mdc-tab-text-label-color-default')
  tabTextLabelColorDefault?: string = undefined;
  @cssProp('--mdc-tab-color-default')
  tabColorDefault?: string = undefined;
}

export const [TabBar] = view('esui-mwc-tab-bar', {
  Props,

  mapBuilder:
    TabBarBuilder =>
    (...tabs: View[]) =>
      TabBarBuilder().tabs(tabs),

  template(props) {
    const activeIndex = useSharedState(props.activeIndex);

    function handleTabChange(e: { detail: { index: number } }) {
      activeIndex.value = e.detail.index;
    }

    return html`
      <mwc-tab-bar
        activeIndex="${props.activeIndex.value}"
        @MDCTabBar:activated="${handleTabChange}"
      >
        ${props.tabs.map(tab => tab.body)}
      </mwc-tab-bar>
    `;
  },
});
